import { importAndInitializePubNub } from 'core_main/helpers/vendors';
import { createSharedCustomerChannelString } from 'core_main/pubnub/helpers';
import { getStore } from 'core_main/store';
import { PRESENCE_OFFLINE, PRESENCE_ONLINE } from './contants';
import { SendPresenceActivityParameters } from './types';
import { validateSendPresenceActivityParams } from './helpers';

export const sendPresenceActivity = (
  parameters: SendPresenceActivityParameters,
) => {
  const store = getStore();

  const { orgId, customerId } = store;

  if (!customerId) return undefined;

  try {
    const validateSendPresenceActivityParamsError = validateSendPresenceActivityParams(
      parameters,
    );

    if (validateSendPresenceActivityParamsError) {
      throw validateSendPresenceActivityParamsError;
    }

    return importAndInitializePubNub().then((module) => {
      const pubnub = module;

      const presence = parameters?.presence;

      if (typeof pubnub === 'object') {
        if (presence === PRESENCE_ONLINE) {
          pubnub.subscribe({
            channels: [createSharedCustomerChannelString(customerId, orgId)],
            withPresence: true,
          });
        }

        if (presence === PRESENCE_OFFLINE) {
          pubnub.unsubscribe({
            channels: [createSharedCustomerChannelString(customerId, orgId)],
          });
        }
      }
    });
  } catch (error) {
    console.error('Failed to send presence acitivity', error);
    return undefined;
  }
};
